export const API_URL = process.env.API_URL || "/api";
